import React from "react";

export const TsAdminContext = React.createContext<any>(null);